<script lang="ts">
  import type { Prompts } from '../prompts.svelte';

  const { prompts }: { prompts: Prompts } = $props();

  let dialog = $state<HTMLDialogElement>();

  $effect(() => {
    if (!dialog) return;
    if (prompts.pending && !dialog.open) dialog.showModal();
    else if (!prompts.pending && dialog.open) dialog.close();
  });

  function cancel(event: Event) {
    event.preventDefault();
    prompts.answer(false);
  }
</script>

<!-- Modal, so it sits above the layout and never resizes the canvas. -->
<dialog bind:this={dialog} aria-label="Confirm" oncancel={cancel}>
  {#if prompts.pending}
    <p>{prompts.pending.message}</p>
    <div class="actions">
      <button type="button" onclick={() => prompts.answer(false)}>Cancel</button>
      <button type="button" class="confirm" onclick={() => prompts.answer(true)}>
        {prompts.pending.confirmLabel}
      </button>
    </div>
  {/if}
</dialog>

<style>
  dialog {
    width: 24rem;
    max-width: calc(100vw - 2 * var(--space-3));
    padding: var(--space-3);
    border: 1px solid var(--color-border);
    border-radius: var(--radius);
    background: var(--color-surface);
    color: var(--color-text);
    box-shadow: 0 12px 30px rgb(0 0 0 / 0.18);
  }

  dialog::backdrop {
    background: rgb(0 0 0 / 0.3);
  }

  p {
    margin: 0 0 var(--space-3);
    font-size: 0.875rem;
  }

  .actions {
    display: flex;
    justify-content: flex-end;
    gap: var(--space-2);
  }

  button {
    padding: 5px 12px;
    border: 1px solid var(--color-border);
    border-radius: 6px;
    background: var(--color-bg);
    color: var(--color-text);
    font: inherit;
    font-size: 0.8125rem;
    cursor: pointer;
  }

  .confirm {
    border-color: var(--color-accent);
    background: var(--color-accent);
    color: #fff;
  }
</style>
